import React from 'react';
import { Box } from '@mui/material';
import discoverImg from '../assets/images/discover-img.jpg';
import DiscoverCard from './DiscoverCard';

function DiscoverSection() {
  return (
    <Box sx={{
        height: '75vh',
        backgroundImage: `url(${discoverImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex'
    }}>
        <DiscoverCard variant='h5' name='Build your project' description='Plan your new home or commercial space with PR Builders in East Tambaram, Chennai—quality construction, clear communication, and design that fits Tambaram and South Chennai lifestyles.' buttonTitle='Our projects' buttonLink='/projects' />
    </Box>
  )
}

export default DiscoverSection;